import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  Typography,
  Paper,
  TextField,
  Button,
} from "@mui/material";
import QuestionType from "./QuestionType";

import request from "../../../../utilities/requests";

const RangeQuestion = ({ questionData }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [changed, setChanged] = React.useState(false);

  const handleLabelChange = (field, value) => {
    question[field] = value;
    setQuestion({ ...question });
    setChanged(true);
  };

  const handleValueChange = (field, value) => {
    question[field] = value;
    if (question.lowerRangeValue >= question.upperRangeValue) {
      alert("The lower range value must be less than the upper range value");
      return;
    }
    setQuestion({ ...question });
    setChanged(true);
  };

  const handleSave = async () => {
    const result = await request("matchmaking/question", "post", question);
    if (result.success) {
      setChanged(false);
    }
  };

  return (
    <Grid item>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Grid item xs={11} md={2}>
          <TextField
              value={question?.question}
              variant="standard"
              size="small"
              fullWidth
              multiline
              maxRows={3}
              style={{ paddingRight: 10 }}
              onChange={(e) => handleValueChange('question', e.target.value)}
            />
          </Grid>
          <Grid item xs={11} md={1}>
            <QuestionType label="Range" />
          </Grid>
          <Grid item xs={6} md={2}>
            <TextField
              value={question?.lowerRangeLabel}
              variant="standard"
              helperText="Lower Range Label"
              size="small"
              onChange={(e) =>
                handleLabelChange("lowerRangeLabel", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={6} md={2}>
            <FormControl size="small">
              <Select value={question?.lowerRangeValue} onChange={(e) => handleValueChange('lowerRangeValue', e.target.value)}>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
              <FormHelperText>Lower Range</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6} md={2}>
            <TextField
              value={question?.upperRangeLabel}
              variant="standard"
              helperText="Upper Range Label"
              size="small"
              onChange={(e) =>
                handleLabelChange("upperRangeLabel", e.target.value)
              }
            />
          </Grid>
          <Grid item xs={6} md={2}>
          <FormControl size="small">
              <Select value={question?.upperRangeValue} onChange={(e) => handleValueChange('upperRangeValue', e.target.value)}>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
              <FormHelperText>Upper Range</FormHelperText>
            </FormControl>
          </Grid>
          {changed ? (
            <Grid item xs={12} md={2}>
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default RangeQuestion;
